import React, { useEffect } from 'react';
import { useAccountContext } from '../AccountContext';
import { toFormattedDate } from '../../../utilities/FormatHelpers';
import { useCurrentBillingPeriod, useGetBillingPeriods } from '@app/sdk';

export default function BillingPeriodSelector() {
  const { accountId, selectedBillingPeriod, setSelectedBillingPeriod } = useAccountContext();
  const { data: billingPeriods } = useGetBillingPeriods(accountId);
  const { data: currentBillingPeriod } = useCurrentBillingPeriod(accountId);

  useEffect(() => {
    setSelectedBillingPeriod(currentBillingPeriod);
  }, [currentBillingPeriod]);

  return (
    <div className="ui">
      {billingPeriods?.map((bp) => (
        <button
          key={bp.billingPeriodId}
          style={{ marginBottom: '5px' }}
          className={`ui button ${bp.billingPeriodId == selectedBillingPeriod?.billingPeriodId ? 'active' : ''}`}
          onClick={() => setSelectedBillingPeriod(bp)}>
          Billing Period {bp?.billingPeriodId}{' '}
          {currentBillingPeriod?.billingPeriodId == bp?.billingPeriodId ? '(Current)' : ''}
          <div className="ui grey sub header">
            {toFormattedDate(bp?.startDate)} - {toFormattedDate(bp?.endDate)}
          </div>
        </button>
      ))}
    </div>
  );
}
